import { ADD_SET, ADD_MISTAKE, ADD_POINTS, SET_LEVEL, SET_LEVEL_ID, SET_MOVES, SET_FAILED, SET_PALETTE } from './types';

import { setSquares } from './squares';
import {addTool} from './tools';
import { randomBoard } from '../utilities';

import getLevelDef from '../level_definitions';

export function setPalette(palette) {
  return {
    type : SET_PALETTE,
    payload : palette,
  }
}

export function addSet(set) {
  return {
    type : ADD_SET,
    payload : set,
  }
}

export function addMistake(mistake_set) {
  return {
    type : ADD_MISTAKE,
    payload : mistake_set
  }
}

export function addPoints(points) {
  return {
    type : ADD_POINTS,
    payload : points
  }
}

export function setLevel(level) {
  return (dispatch) => {

    let leveldef = level;
    if (!(level instanceof Object)) {
      leveldef = getLevelDef(level);
    }

    dispatch({
      type : SET_LEVEL,
      payload : leveldef
    });

    dispatch(setSquares( leveldef.squares || randomBoard(leveldef) ));
    dispatch(setMoves(leveldef.moves));
    if (leveldef.tools) {
      dispatch(addTool(leveldef.tools));
    }

  }
}

export function setLevelID(levelID) {
  return {
    type: SET_LEVEL_ID,
    payload:levelID,
  }
}

export function setFailed(failed) {
  return {
    type: SET_FAILED,
    payload:failed,
  }
}

export function setMoves(moves) {
  return {
    type : SET_MOVES,
    payload : moves
  }
}



// WEBPACK FOOTER //
// ./src/actions/level.js